import Modal from "react-modal";

const Popup = (props: any) => {
  const { children, show, setShow, title, maxWidth = 650 } = props;

  const handleClose = () => {
    setShow(false);
  };

  return (
    <Modal
      isOpen={show}
      onRequestClose={handleClose}
      ariaHideApp={false}
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 99999,
        },
        content: {
          border: "none",
          backgroundColor: "#F9FAFB",
          maxWidth: maxWidth,
          maxHeight: "fit-content",
          margin: "auto",
          overflowX: "hidden",
          padding: 0,
          borderRadius: 15,
          inset: 5,
        },
      }}
    >
      <div className="bg-darknavy text-white text-2xl font-bold text-center py-3 relative">
        {title}
        <button
          onClick={handleClose}
          className="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-gray-300 transition-colors"
          aria-label="Close popup"
        >
          ✕
        </button>
      </div>
      <div className="max-h-[90vh] p-6 overflow-y:auto">{children}</div>
    </Modal>
  );
};
export default Popup;
